import axios from 'axios';
import { apiUrl, walmartAdapterUrl } from '../constant';
import authHeader from './auth-header';

/**
 * Marketplace Listing Service
 *
 * Calls the new Push-to-Marketplace endpoints across:
 *   - walmart-service (integration hub) for prepare / publish / withdraw
 *   - WMS-API (.NET) for the persisted-listing read used by row badges
 *
 * walmart-service responses come in Format A `{ success, data, error }`.
 * Callers receive that envelope as-is; the modal reads `response.data.data`
 * for success payloads and `response.data.error` for protocol-level errors.
 *
 * The .NET response is the standard PayloadCustom Format B
 * (`{ EntityList, Status, Message }`). No normalization needed.
 */

// ── walmart-service (integration hub) ────────────────────────────────────────

/**
 * POST /marketplace/:marketplace/listing/prepare
 * Returns the bundle the modal needs to open: product, suggested category,
 * required/recommended/optional aspects, business policies, locations.
 */
export const prepareListing = (marketplace, data) => {
    return axios.post(
        `${walmartAdapterUrl}/marketplace/${marketplace}/listing/prepare`,
        data,
        { headers: authHeader() },
    );
};

/**
 * POST /marketplace/:marketplace/listing/publish
 * Submits the filled form to be published as a live marketplace listing.
 * Returns 200 even on marketplace-side failure; check response.data.data.success.
 */
export const publishListing = (marketplace, data) => {
    return axios.post(
        `${walmartAdapterUrl}/marketplace/${marketplace}/listing/publish`,
        data,
        { headers: authHeader() },
    );
};

/**
 * POST /marketplace/:marketplace/listing/withdraw
 * Unlist / end an existing marketplace listing.
 */
export const withdrawListing = (marketplace, data) => {
    return axios.post(
        `${walmartAdapterUrl}/marketplace/${marketplace}/listing/withdraw`,
        data,
        { headers: authHeader() },
    );
};

// ── WMS-API (.NET) — persisted listing rows ─────────────────────────────────

/**
 * POST /api/MarketplaceListing/GetByInventoryId
 * Returns all marketplace listings already persisted for an inventory item.
 * Drives create-vs-update routing in the modal and the row-level badge.
 */
export const getListingsByInventoryId = (data) => {
    return axios.post(
        `${apiUrl}/api/MarketplaceListing/GetByInventoryId`,
        data,
        { headers: authHeader() },
    );
};

/**
 * POST /api/MarketplaceListing/GetBySeller
 * Paginated read for a seller-wide marketplace listing view.
 */
export const getListingsBySeller = (data) => {
    return axios.post(
        `${apiUrl}/api/MarketplaceListing/GetBySeller`,
        data,
        { headers: authHeader() },
    );
};
